// Gates
export const MULTIPLE_OUTCOMES_GATE = 'Forecasting:MultipleOutcomes';

/// Scopes
export const DEAL_TAGS_ACCESS_SCOPE = 'crm-pipelines-object-label-access';